module.exports = __webpack_public_path__ + "img/gongzuotai.41ceae37.png";